import { Button, ButtonVariants } from '@components/button/Button';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';

export interface DisconnectLightspeedModalProps {
  isOpen: boolean;
  isDisconnecting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DisconnectLightspeedModal = ({
  isOpen,
  isDisconnecting,
  onClose,
  onConfirm,
}: DisconnectLightspeedModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Disconnect Lightspeed"
    subtitle="Reservations will no longer sync to Lightspeed for this restaurant until you connect again."
  >
    <ModalActions>
      <Button
        label="Cancel"
        onClick={onClose}
        variant={ButtonVariants.Tertiary}
        isDisabled={isDisconnecting}
      />
      <Button
        label="Disconnect"
        onClick={onConfirm}
        variant={ButtonVariants.Error}
        isDisabled={isDisconnecting}
      />
    </ModalActions>
  </Modal>
);
